/*
 * @Author: wjl
 * @Date: 2020-04-21 14:23:13
 * @LastEditors: hxz
 * @LastEditTime: 2024-04-07 16:43:02
 * @FilePath: \appOfficial\src\utils\fan.js
 */
module.exports = {
  bottomList: {
    0: { title: "關注我們", two: "微信", thre: "新浪微博" },
    1: {
      title: "加入我們",
      two: "社會招聘",
      thre: "校園招聘",
      for: "國際招聘",
    },
    2: { title: "聯繫我們", two: "客戶服務", thre: "合作洽談" },
  },
  bottomTxt: {
    0: "Copyright © 2018-2019 jinling. All Rights Reserved. 金齡科技公司 版權所有",
    1: {
      0: "友情連結: ",
      1: "金齡科技",
      2: "中國老年大學協會",
      3: "中國老年學和老年醫學學會",
      4: "網上老年大學",
    },
    2: { 0: "備案號：", 1: "粵ICP備19021271號" },
  },
  modelList: [
    { title: "金齡科技公眾號", img: require("@/images/wechat.jpg") },
    { title: "掃碼添加客服微信", img: require("@/images/service.jpeg") },
    {
      title: "合作洽談",
      img: require("@/images/cooperate.png"),
      number: "0755-2692 0484",
    },
  ],
};
